(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const menus = Array.from(document.querySelectorAll('.stinebe-nav__details'));
  if (!menus.length) return;

  const closeOthers = (current) => {
    menus.forEach((menu) => {
      if (menu !== current) menu.removeAttribute('open');
    });
  };

  menus.forEach((menu) => {
    let closeTimer;

    const openMenu = () => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeOthers(menu);
      menu.setAttribute('open', '');
      menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      if (!desktopQuery.matches) return;
      closeTimer = window.setTimeout(() => {
        if (!menu.contains(document.activeElement)) {
          menu.removeAttribute('open');
          menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      }, 140);
    };

    menu.addEventListener('pointerenter', openMenu);
    menu.addEventListener('pointerleave', closeMenu);
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('focusout', closeMenu);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    menus.forEach((menu) => menu.removeAttribute('open'));
  });
})();
